import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspRedeemItemService } from './asp-redeem-item.service';
import { ToastrService } from 'ngx-toastr';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { Router } from '@angular/router';
import { AspLoginService } from '../asp-login/asp-login.service';

@Component({
  selector: 'app-asp-redeem-item',
  templateUrl: './asp-redeem-item.component.html',
  styleUrls: ['./asp-redeem-item.component.scss']
})
export class AspRedeemItemComponent implements OnInit {


  products: any;
  cartList= [];
  newData= {};
  addedRedeem: any[];
  selectedCategory: string;
  walletAmount: any;
  categories: any;
  selectedSubCategories: any;
 selectedCategories: string[] = [];



  constructor(
   private aspRedeemItemService: AspRedeemItemService,
   private toastr: ToastrService,
   private aspLoadingService: AspLoadingService,
   public router: Router,
   private aspLoginService: AspLoginService,
  ) { }

     @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  ngOnInit(): void {
    this.aspLoginService.checkLogin();
    this.getCategories();
    this.getCart();
    
    this.updateCartCount();
   }
   
selectCategory(categoryName: string) {
  
    this.getSubCategories(categoryName);
   this.aspLoadingService.show();
  this.selectedCategory = categoryName;
  // console.log("selectedCategory",this.selectedCategory);
  this.categories.forEach(c => c.isActive = c.categoryName === categoryName);
  // console.log("categories",this.categories);
  const categoryParam = categoryName === 'All' ? ' ' : categoryName;
  this.aspRedeemItemService.redeemSpare(categoryParam,[]).subscribe(res=>{
     this.aspLoadingService.hide();
    // console.log("res",res);
    this.walletAmount=res['data'].walletAmount;
    this.products = res['data']?.spares?.map(spare => {
  return {
    ...spare,
    mrp: spare.mrp / 100  // Convert paise to rupees
  };
});

  })
}


increaseQuantity(product: any) {
  product.quantity++;
}

decreaseQuantity(product: any) {
  if (product.quantity > 1) {
    product.quantity--;
  } else {
    product.quantity = 0; // Hide quantity counter
  }
}
getCategories() {
  this.aspRedeemItemService.getCategories().subscribe(result => {
    // console.log("result", result);

    // Sort with "All" first if present
    this.categories = result['data']
      .map(item => ({
        ...item,
        isActive: false // default inactive
      }))
      .sort((a, b) => {
        if (a.categoryName === 'All') return -1;
        if (b.categoryName === 'All') return 1;
        return 0;
      });

    // Determine which category to select
    if (this.categories.length > 1) {
      this.selectCategory('All');
    } else if (this.categories.length === 1) {
      this.selectCategory(this.categories[0].categoryName);
    }
  });
}


 getCart(){
    let cartData;  
    this.cartList = [];
    // this.cartCount = 0;
    // this.cartSubTotal = 0;
    // this.cartGrandTotal = 0;
    
    if(localStorage.getItem('addedRedeem')){   
      cartData = JSON.parse(localStorage.getItem('addedRedeem'));
      if(Object.keys(cartData[0]).length==0){
        // this.isCartCount = false;
      } 
      
      Object.values(cartData[0]).forEach(cart => { 
        if(cart){
          // this.isCartCount = true;
          // this.cartCount++;
        

        // this.cartCount += cart['cart_qty'];
        // if(cart['sellingPrice']>0){
        //   this.cartSubTotal += (cart['sellingPrice']*cart['cart_qty']);
        // }else{
        //   this.cartSubTotal += (cart['mrp']*cart['cart_qty']);
        // }
        this.cartList.push(cart);
      }
      });      

      this.cartList = cartData;
      // this.cartGrandTotal = this.cartSubTotal;
      // console.log('this.cartList',this.cartList);

      // if(this.cartCount>0){
      //   (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
      // }else{
      //   (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
      // }
    //   if(this.sparesDiscount>0){
    //     this.cartGrandTotal = (this.cartSubTotal - this.sparesDiscount);
    // }else{
    //     this.cartGrandTotal = this.cartSubTotal;
    // }
    // this.getShippingCharges()
  
    }
    // console.log("cartList",this.cartList)
  }
    redeemProduct(items, count){
    // console.log("items",items);
    // console.log("count",count);
    delete items.rowKey;
    delete items.variantKey;

    // if(this.isReplacePopup==true){
    //   sessionStorage.setItem('replaceCart', JSON.stringify(items));
    //   this.zone.run(() => {
    //     this.dialog.open(AspReplaceCartPopupComponent);
    //   });
    // }else{
    //   this.setNewMakeAsMake();
        
      this.addedRedeem = [];
      if(localStorage.getItem('addedRedeem')){
        this.newData = JSON.parse(localStorage.getItem('addedRedeem'))[0];
        // console.log("items.cart_qty",items.cart_qty);
        items.cart_qty = count;
        items = {
         
          ...items, 
          ...items.spareStocks, 
         };

        items.discount = items.discountAmount;  
        delete items.discountAmount;
        this.newData[items.key] = items;
        this.addedRedeem.push(this.newData);
        localStorage.setItem('addedRedeem', JSON.stringify(this.addedRedeem));
      }else{
        items.cart_qty = count;
        // this.amount=items.spareStocks;
        items = {
          ...items,
          ...items.spareStocks,    
        };
        items.discount = items.discountAmount;  
        delete items.discountAmount;
        this.newData[items.key] = items;
        this.addedRedeem.push(this.newData);
        localStorage.setItem('addedRedeem', JSON.stringify(this.addedRedeem));
      }      
      this.getCart();
      
      this.updateCartCount();
    // }
  }
  removeItem(count, item){ 
    this.addedRedeem = [];    
    let data;
    
    data = JSON.parse(localStorage.getItem('addedRedeem'))[0];
    if(count>1){
      let countval = count-1;
      data[item].cart_qty = countval;


      this.addedRedeem[0] = data;
      localStorage.setItem('addedRedeem', JSON.stringify(this.addedRedeem));
      this.getCart();
    }else{
      this.deleteItem(item);
      this.toastr.error(data[item].name+' removed from cart', 'Cart Item');
    }
  }
  deleteItem(item){
    this.newData = {};
    let cartData;

    cartData = JSON.parse(localStorage.getItem('addedRedeem'));
    Object.values(cartData[0]).forEach(cart => { 
      if(cart['key']!=item) {
        this.newData[cart['key']] = cart;
      }
    });
    
    this.addedRedeem[0] = this.newData;
    localStorage.setItem('addedRedeem', JSON.stringify(this.addedRedeem));
    this.getCart();
    // console.log(this.addedRedeem);
    
  this.updateCartCount();
  }

  addItem(count, item){
    let countval = count+1;
    
    // this.addCart(item,countval);
    this.addedRedeem = [];
    let data;
    
    // data = JSON.parse(localStorage.getItem('addedRedeem'))[0];
    // if(countval<=data[item].spareStocks.quantity){
    //   data[item].cart_qty = countval;

    //   if(this.vehicleType=='universal'){
    //     data[item].type = 'universal';
    //   }

    //   this.addedRedeem[0] = data;
    //   localStorage.setItem('addedRedeem', JSON.stringify(this.addedRedeem));
    //   this.getCart();
    // }else{
    //   this.toastr.error('Only '+data[item].spareStocks.quantity+' unit available for this item', 'Error');
    // }
    data = JSON.parse(localStorage.getItem('addedRedeem'))[0];
    // if(countval<=data[item].spareStocks.quantity){
      data[item].cart_qty = countval;
      this.addedRedeem[0] = data;
      // console.log("this.addedRedeem",this.addedRedeem)
      localStorage.setItem('addedRedeem', JSON.stringify(this.addedRedeem));
      this.getCart();
  }
  cart(){
    localStorage.setItem("redeemCart",'true');
    localStorage.setItem("walletBalance",this.walletAmount)
     this.router.navigate(['cart']);
  }
   back(){
      this.router.navigate(['home']);
  }
  updateCartCount() {
  const data = localStorage.getItem('addedRedeem');
  let count = 0;

  if (data) {
    const parsed = JSON.parse(data);
    if (Array.isArray(parsed) && parsed.length > 0 && typeof parsed[0] === 'object') {
      count = Object.keys(parsed[0]).length;
    }
  }

  const countElement = document.getElementById('cartCount');
  if (countElement) {
    countElement.textContent = count.toString();
  }
}
 getSubCategories(categoryName: string) {
  
    // console.log("categoryName",categoryName)
    const category = this.categories.find(c => c.categoryName === categoryName);
    this.selectedSubCategories = category ? category.subCategoriesName : [];
    // console.log("sub",this.selectedSubCategories)
  }
  passSubCategories(categoryParam,subCategories){

  }
    toggleSubCategory(sub: string) {
    const index = this.selectedCategories.indexOf(sub);
    if (index > -1) {
      this.selectedCategories.splice(index, 1); // Remove
    } else {
      this.selectedCategories.push(sub); // Add
    }
    const payload =[ {
           [this.selectedCategory ]: this.selectedCategories
            }
          ]
              this.aspLoadingService.show();
          this.aspRedeemItemService.redeemSpare(this.selectedCategory,payload).subscribe(res=>{
     this.aspLoadingService.hide();
    // console.log("res",res);
    this.walletAmount=res['data'].walletAmount;
    this.products = res['data']?.spares?.map(spare => {
  return {
    ...spare,
    mrp: spare.mrp / 100  // Convert paise to rupees
  };
});

  })
  }

  isSelected(sub: string): boolean {
    return this.selectedCategories.includes(sub);
  }

scrollLeft(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: -150, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: 150, behavior: 'smooth' });
  }
}

